export function errorToToastMessage(err: unknown): string {
  // TODO: handle ApolloError specifically?
  if (err instanceof Error) {
    return err.message;
  }
  return "Unknown error";
}
